import React from 'react';
import { useLocation } from 'react-router-dom';
import { URL_ROOT_QUOTE } from '../../routes';
import { useSessionFooter } from '../../hooks';
import { useStickyBarHeight } from '../landing/StickyBarHeightProvider';

import './QuotingFooter.css';
import { FooterLinks } from '../common/FooterLinks';

const QuotingFooter = ({
  classContainer = '',
  customFooterText = '',
}) => {
  const sessionFooter = useSessionFooter();
  const { stickyBarHeight } = useStickyBarHeight();

  const location = useLocation();
  const currentLocation = location.pathname.toLocaleLowerCase();
  const marginList = [URL_ROOT_QUOTE];
  const containerStyle = marginList.indexOf(currentLocation) >= 0
    ? 'Quoting-footer-extra-margin' : '';

  return (
    <footer
      className={`Quoting-footer-container ${containerStyle} ${classContainer}`}
      style={{ marginBottom: stickyBarHeight }}
    >
      <div className="Quoting-footer-content">
        <p className="Quoting-footer-text-header">
          {`Copyright © 2015 – ${new Date().getFullYear()}
           Figo Pet Insurance LLC. All rights reserved.`}
        </p>

        <FooterLinks className="Quoting-footer-text-spacing" />

        <p className="Quoting-footer-text">
          {customFooterText || sessionFooter}
        </p>
      </div>
    </footer>
  );
};

export default QuotingFooter;
